import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
    children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated, user } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (user?.auth_type === 'institution' && user?.email_verified === false) {
        // Prevent redirect loop if already on verify page or register
        if (!location.pathname.startsWith('/auth/institution')) {
             return <Navigate to="/auth/institution/verify" replace />;
        }
    }

    return <>{children}</>;
}
